import { ClearOutlined, FieldTimeOutlined, LeftSquareOutlined, ReadOutlined, RightSquareOutlined, SkinOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, Divider, Row, Tooltip, message } from "antd";
import { CLEANING_AUDIT, COMMUNICATION, EDUCATION_TOOLBOX, FACILITY_MANAGEMENT, LAUNDRY_AUDIT, PERIODICAL, FACILITY_PORTAL } from "MyMConstants";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFacilityByModule } from "redux/actions/getFacilityByModule.action";
import { getApiArrayDetails, isValidArray } from "../../../utils/MyMUtils";

function Step3(props) {
  const dispatch = useDispatch();
  const [info, setInfo] = useState([]);
  const [able, setAble] = useState([]);

  const getFacilityList = useSelector((state) => getApiArrayDetails(state.getFacilityByModule.data));

  useEffect(() => {
    dispatch(getFacilityByModule(props.passData.role));
  }, []);

  useEffect(() => {
    props.selectFacility(info);
    return () => { };
  }, [info]);

  function onChangeFacility({ target: { value, checked } }) {
    let ableValue;
    setAble((state) => {
      ableValue = checked ? [...state, value] : state.filter((id) => id !== value);
      return checked ? [...state, value] : state.filter((id) => id !== value);
    });

    if (!checked) {
      setInfo((state) => {
        return state.filter(({ facility_id }) => facility_id !== value);
      });
    }

    const facilityData = getFacilityList.find((e) => e.facility_id == value);

    const facilityDataIndex = info?.findIndex((e) => e.facility_id == value);

    const checkboxes = document.querySelectorAll(`input[id="${value}"]`);
    checkboxes.forEach((e) => {
      if (e.id == value) {
        e.checked = checked;
      }
    });

    facilityData?.modules?.forEach((module) => {
      setInfo((state) => {
        if (checked) {
          return setCheckedId({
            fac_id: value,
            mod_id: module.module_id,
            data: state,
            able: ableValue,
          });
        } else {
          return unSetCheckedId({ fac_id: value, mod_id: module.module_id, data: state, able: ableValue });
        }
      });
    });
  }

  const setCheckedId = ({ fac_id, mod_id, data, able }) => {
    if (isValidArray(data)) {
      let status = false;
      let len = data.length - 1;

      const newData = data.map((e, i) => {
        const { facility_id, modules } = e;
        if (facility_id == fac_id) {
          modules.push(mod_id);
          return { facility_id, modules };
        }

        if (able.includes(fac_id) && len == i) {
          status = true;
        }

        return e;
      });

      return !status ? newData : [...newData, { facility_id: fac_id, modules: [mod_id] }];
    }
    data.push({ facility_id: fac_id, modules: [mod_id] });
    return data;
  };

  const unSetCheckedId = ({ fac_id, mod_id, data }) => {
    const newData = data.map((e) => {
      const { facility_id, modules } = e;
      if (facility_id == fac_id) {
        const newModule = modules.filter((id) => id != mod_id);
        if (newModule?.length == 1 && newModule[0] == 24) {
          onChangeFacility({ target: { value: fac_id, checked: false } })
        }
        return { facility_id, modules: newModule };
      }
      return e;
    });
    return newData;
  };

  const onSelectModule = ({ target: { value, id, checked } }) => {
    setInfo((state) => {
      if (checked) {
        return setCheckedId({
          fac_id: id,
          mod_id: value,
          data: state,
          able: able,
        });
      } else {
        return unSetCheckedId({ fac_id: id, mod_id: value, data: state });
      }
    });
  };

  const next = () => {
    if (props.passData.facility.length > 0) {
      props.next();
    } else {
      message.error("Please select the facility and its module.");
    }
  };

  const prev = () => {
    props.prev();
  };

  const getmodulesIds = (data) => {
    if (data) {
      return data?.modules?.map((module) => {
        return module;
      });
    }
  };

  return (
    <>
      <div className="steps-content">
        <p></p>
        <Divider orientation="left" style={{ fontSize: "22px" }}>
          Select Facility - Module
        </Divider>
        <p></p>
        <Row gutter={24} style={{ marginLeft: "0px", marginRight: "0px" }}>
          {getFacilityList &&
            getFacilityList.map((facility) => {
              return (
                <>
                  <Col lg={10} md={8} sm={24} xs={24} key={facility.facility_id}>
                    <Row gutter={24}>
                      <Col lg={24} md={24} sm={24} xs={24}>
                        <div className="outer-radio-facility">
                          {isValidArray(props?.passData?.facility) ? (
                            <Checkbox.Group
                              value={able}
                            >
                              <Checkbox value={facility.facility_id} id={facility.facility_id} onChange={onChangeFacility}>
                                {facility.facility_name}
                              </Checkbox>
                            </Checkbox.Group>
                          ) : (
                            <Checkbox.Group value={able}> 
                              <Checkbox value={facility.facility_id} id={facility.facility_id} onChange={onChangeFacility}>
                                {facility.facility_name}
                              </Checkbox>
                            </Checkbox.Group>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={14} md={16} sm={24} xs={24}>
                    <Row gutter={24}>
                      {facility.modules &&
                        facility?.modules.map((module) => {
                          return (
                            <>
                              {module.name !== FACILITY_PORTAL && module.name !== FACILITY_MANAGEMENT && module.name !== COMMUNICATION && (
                                <Col lg={6} md={6} sm={6} xs={6}>
                                  <Tooltip title={module?.name} color="rgb(47, 111, 224)">
                                    <div className="outer-radio-facility">
                                      <Checkbox.Group
                                        value={info && getmodulesIds(...info?.filter((e) => e.facility_id === module.facility_id))}
                                        defaultValue={isValidArray(props?.passData?.facility) ? getmodulesIds(...props.passData?.facility?.filter((e) => e.facility_id === module.facility_id)) : null}
                                      >
                                        <Checkbox value={module.module_id} id={module?.facility_id} onChange={onSelectModule} disabled={!able.includes(module?.facility_id)}>
                                          {module.name === CLEANING_AUDIT && (
                                            <ClearOutlined
                                              className="ml-3"
                                              style={{
                                                fontSize: "22px",
                                              }}
                                            />
                                          )}
                                          {module.name === EDUCATION_TOOLBOX && (
                                            <ReadOutlined
                                              className="ml-3"
                                              style={{
                                                fontSize: "22px",
                                              }}
                                            />
                                          )}
                                          {/* {module.name === FACILITY_MANAGEMENT && (
                                          <BankOutlined
                                            className="ml-3"
                                            style={{
                                              fontSize: "22px",
                                            }}
                                          />
                                        )} */}
                                          {module.name === PERIODICAL && (
                                            <FieldTimeOutlined
                                              className="ml-3"
                                              style={{
                                                fontSize: "22px",
                                              }}
                                            />
                                          )}
                                          {module.name === LAUNDRY_AUDIT && (
                                            <SkinOutlined
                                              className="ml-3"
                                              style={{
                                                fontSize: "22px",
                                              }}
                                            />
                                          )}
                                        </Checkbox>
                                      </Checkbox.Group>
                                    </div>
                                  </Tooltip>
                                </Col>
                              )}
                            </>
                          );
                        })}
                    </Row>
                  </Col>
                </>
              );
            })}
        </Row>
      </div>
      <Row gutter={24} className="mt-2">
        <Col lg={12} md={12} sm={24} xs={24}></Col>
        <Col lg={12} md={12} sm={24} xs={24} className="text-right">
          <Button shape="round" className="mr-3" icon={<LeftSquareOutlined />} onClick={prev}>
            Prev
          </Button>
          <Button shape="round" icon={<RightSquareOutlined />} onClick={next}>
            Next
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default Step3;
